import DiscordContent from '@/components/home/DiscordContent'
import MainContent, { useHomeViewType } from '@/components/home/MainContent'
import WechatContent from '@/components/home/WechatContent'
import useUserProfile from 'hooks/useUserProfile'
import type { NextPage } from 'next'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import { useMemo } from 'react'
import { HomeViewType } from 'types/home'

const Home: NextPage = () => {
  const [homeViewType] = useHomeViewType()
  const { data: session } = useSession()
  const { data: userProfile, mutate, isLoading } = useUserProfile(session ? 10_000 : 0)
  const { refreshTokenExpiresAt } = userProfile?.userMuseDamToken || {}

  const refreshTokenExpired = useMemo(() => {
    return !refreshTokenExpiresAt || new Date(refreshTokenExpiresAt).valueOf() < Date.now()
  }, [refreshTokenExpiresAt])

  const needLogin = useMemo(() => {
    return !session || refreshTokenExpired
  }, [refreshTokenExpired, session])

  return (
    <>
      <div className="fixed inset-0 overflow-hidden pointer-events-none text-foreground">
        <div className="absolute left-0 top-0 w-[40vw] h-[50vw]">
          <Image src="/bg-blur-tl.png" alt="" className="absolute inset-0" fill />
        </div>
        <div className="absolute right-0 bottom-0 w-[60vw] h-[40vw]">
          <Image src="/bg-blur-br.png" alt="" className="absolute inset-0" fill />
        </div>
      </div>
      {typeof homeViewType === 'undefined' && isLoading ? (
        <div className="w-full h-screen flex justify-center items-center">
          <div className="w-10 h-10 relative border-[4px] rounded-full border-t-slate-300 border-accent-600/80 animate-spin"></div>
        </div>
      ) : (
        <main className="w-full pt-[30px] md:pt-0">
          {homeViewType === HomeViewType.Wechat ? (
            <WechatContent
              userProfile={!needLogin ? userProfile : undefined}
              onGetUserProfile={mutate}
              needLogin={needLogin}
            />
          ) : homeViewType === HomeViewType.Discord ? (
            <DiscordContent
              userProfile={!needLogin ? userProfile : undefined}
              onGetUserProfile={mutate}
              needLogin={needLogin}
            />
          ) : (
            <MainContent
              userProfile={!needLogin ? userProfile : undefined}
              onGetUserProfile={mutate}
              needLogin={needLogin}
            />
          )}

          {/* <Transition
            show={homeViewType === HomeViewType.Default}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <MainContent userProfile={userProfile} onGetUserProfile={mutate} needLogin={needLogin} />
          </Transition>
          <Transition
            show={homeViewType === HomeViewType.Wechat}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <WechatContent userProfile={userProfile} onGetUserProfile={mutate} needLogin={needLogin} />
          </Transition> */}
        </main>
      )}
    </>
  )
}

export default Home
